import { render } from "./QueueEntryList.vue?vue&type=template&id=167a898c&scoped=true&ts=true"
import script from "./QueueEntryList.vue?vue&type=script&lang=ts"
export * from "./QueueEntryList.vue?vue&type=script&lang=ts"

import "./QueueEntryList.vue?vue&type=style&index=0&id=167a898c&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167a898c"]])

export default __exports__